import { takeLatest } from 'redux-saga/effects';
import { OnCallSpecialistTypes } from '~/domain/interfaces/redux/onCallSpecialist/types';
import { onList, onListSuccess, onListFailed } from './List';

const tasks = [
  takeLatest(OnCallSpecialistTypes.LIST, onList),
  takeLatest(OnCallSpecialistTypes.LIST_SUCCESS, onListSuccess),
  takeLatest(OnCallSpecialistTypes.LIST_FAILED, onListFailed),
];

export default tasks;
